<template>
  <div>
    <el-form
      :model="formParams"
      class="elFormClass"
      ref="ruleForm"
      size="small"
      label-width="auto"
    >
      <div class="flex_between_wrap">
        <div v-for="(item, index) in formItem" :key="index" style="width:100%">
          <el-form-item
            :label="item.label"
            :rules="item.rules ? formRules[item.rules] : formRules.not"
            :prop="item.model"
          >
            <el-radio-group
              v-model="formParams[item.model]"
              v-if="item.model == 'agreement'"
            >
              <el-radio
                :label="option.model"
                v-for="option in item.options"
                :key="option.label"
                >{{ option.label }}</el-radio
              >
            </el-radio-group>
            <el-input-number  v-model="formParams[item.model]" v-else-if="item.model=='port'" style="width:100%;text-align: left;" :controls="false"></el-input-number>
            <el-input
              clearable
              v-else
              :placeholder="'请输入' + item.label"
              size="small"
              v-model="formParams[item.model]"
            ></el-input>
          </el-form-item>
        </div>
      </div>
    </el-form>
    <div class="dialog_bottom" style="margin-top:40px">
      <el-button class="dialog_close" size="small" @click="closeDialog"
        >取 消</el-button
      >
      <el-button
        class="dialog_submit"
        size="small"
        style="width:100px"
        type="submit"
        @click="submit"
        >确 定</el-button
      >
    </div>
  </div>
</template>
<script>
export default {
  props: {
    callBack: Function,
  },
  data() {
    return {
      formParams: {
        url: "",
        port: 8003,
        serveName: "asset",
        agreement: "http://",
      },
      menuArr: [],
      formItem: [
        {
          label: "IP地址",
          model: "url", //URL
        },
        {
          label: "端口号",
          model: "port", //端口号
        },
        {
          label: "服务名",
          model: "serveName", //服务名
        },
        {
          label: "前缀选择", //协议
          model: "agreement",
          options: [
            {
              label: "HTTP",
              model: "http://",
            },
            {
              label: "HTTPS",
              model: "https://",
            },
          ],
        },
      ],
    };
  },
  mounted() {},
  methods: {
    init() {
      if (window.localStorage.getItem("systemSetting")) {
        this.formParams = JSON.parse(
          window.localStorage.getItem("systemSetting")
        );
      }
    },
    submit() {
      if (this.formParams.url) {
        console.log(this.formParams);
        window.localStorage.setItem(
          "systemSetting",
          JSON.stringify(this.formParams)
        );
        let {url,agreement,port,serveName}=this.formParams
        console.log(url,agreement,port,serveName);
        let systemUrl=agreement+url
        if(port){
          systemUrl+=':'
          systemUrl+=port
        }
        if(serveName){
          systemUrl+='/'
          systemUrl+=serveName
        }
        this.callBack(systemUrl)
        this.closeDialog();
      } else {
        this.$message({
          type: "info",
          message: "未配置IP地址",
        });
      }
    },
  },
};
</script>
<style scoped></style>
